module.exports = __webpack_public_path__ + "img/lo_get.bbd51fa.png";